<div class="branding">
  <img [src]="data?.footer_wide_logo_image" alt="" class="cb-logo" />
</div>
